<template>
  <VDialog
    :value="visible"
    width="425"
    persistent
  >
    <VCard
      class="p-0 shadow-none border-radius-8 px-4 py-4 position-relative"
    >
      <VCardTitle class="d-flex">
        <VRow>
          <VCol
            cols="12"
            class="p-0"
          >
            <span class="heading-6">
              {{ $t('editProfile.title') }}
            </span>
          </VCol>
        </VRow>
      </VCardTitle>
      <VCardText class="">
        <VRow justify="center">
          <div class="pt-8">
            <span class="body-1">{{ $t('editProfile.content') }}</span>
          </div>
        </VRow>
      </VCardText>
      <VCardActions class="px-0 pb-0 pt-4">
        <div class="d-flex align-center justify-content-between w-100">
          <div class="w-50 pr-2">
            <VBtn
              v-blur
              class="w-100 body-2 border-radius-8"
              outlined
              large
              color="textTertiary"
              @click="$emit('closeDialogWithoutFormLeave')"
            >
              {{ $t('editProfile.cancel') }}
            </VBtn>
          </div>
          <div class="w-50 pl-2">
            <VBtn
              v-blur
              class="w-100 body-2 border-radius-8"
              dark
              large
              color="brandingPrimary"
              @click="$emit('closeDialog')"
            >
              {{ $t('editProfile.discard') }}
            </VBtn>
          </div>
        </div>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'DiscardChangesDialog',
};
</script>

<script setup lang="ts">
defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
});
</script>
